import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Home, ArrowLeft } from "lucide-react";

export const NotFoundPage = () => {
  return (
    <div className="min-h-screen pt-20 flex items-center justify-center" data-testid="not-found-page">
      <Helmet><title>Page Not Found | SwarmCitadel</title><meta name="robots" content="noindex" /></Helmet>
      <div className="max-w-md mx-auto px-6 text-center">
        <div className="mb-8">
          <h1 className="text-8xl font-bold text-swarm-violet mb-4">404</h1>
          <h2 className="text-2xl font-semibold text-white mb-2">Page not found</h2>
          <p className="text-slate-400">
            The page you&apos;re looking for doesn&apos;t exist or has been moved.
          </p>
        </div>
        
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link to="/">
            <Button className="btn-glow" data-testid="404-home-btn">
              <Home className="w-4 h-4 mr-2" />
              Back to Home
            </Button>
          </Link>
          <Button 
            variant="outline" 
            className="btn-outline"
            onClick={() => window.history.back()}
            data-testid="404-back-btn"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Go Back
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
